<template>
  <b-container fluid class="fixed-bottom d-md-none d-lg-none d-xl-none width-custom d-print-none">
    <div class="row d-flex flex-row justify-content-center m-0 p-0 w-100">


      <slot name="p-1"/>

      <div class="col d-flex flex-column align-items-center">
        <router-link :to="{name:'Dashboard'}">
          <m-ic1 class="p-0 text-dark nav-icon" icon="person-fill"/>
        </router-link>
      </div>
      <div class="col d-flex flex-column align-items-center">
        <router-link v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1" :to="{name:'ShoppingCart'}">
          <m-ic1 class="p-0 text-dark nav-icon" icon="cart-fill"/>
        </router-link>
        <router-link v-else :to="{name:'UnAuthenticatedShoppingCart'}">
          <m-ic1 class="p-0 text-dark nav-icon" icon="cart-fill"/>
        </router-link>
      </div>

      <slot name="p-2"/>

      <div class="col d-flex flex-column align-items-center">
        <router-link :to="{name:'Home'}">
          <m-ic1 class="p-0 text-dark nav-icon" icon="house-fill"/>
        </router-link>
      </div>
      <div class="col d-flex flex-column align-items-center"><a href="javascript:void(0)" @click="goBack">
        <m-ic1 class="p-0 text-dark nav-icon" icon="arrow-left-circle-fill"/>
      </a></div>

      <slot name="p-3"/>


    </div>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Nav200",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
    }),
  }
};
</script>

<style>
.width-custom {
  width: 100% !important;
  background-color: var(--secondary);
}

.nav-icon {
  font-size: 20px;
  margin-top: 20px;

}
</style>